import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { Modal } from '../../components';
import moment from 'moment';
import get from 'lodash/get';
import { dateFromAPIToLocalNoon, getDateForEmail } from '../../util/dates';
import css from './RescheduleSaleModal.css';
import { txLastTransition } from '../../util/transaction';
import {
  TRANSITION_REQUEST_PAYMENT,
  TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY,
  TRANSITION_ACCEPT_NEGOTIATE_OFFER,
  TRANSITION_SAVE_EXTEND_BOOKING,
  TRANSITION_ACCEPT_EXTEND_BOOKING,
} from '../../util/customTransaction/mainRentalTransaction';
import { RescheduleSaleForm } from '../../forms';

const RescheduleSaleModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    transaction,
    onRescheduleSale,
    rescheduleInProgress,
    rescheduleSaleError,
    timeSlots,
    listing,
    isOwnListing,
    onFetchReofferTransactionLineItem,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendMessageButton,
    onChangeAvailabilityExceptionCurrentBooking,
    exceptionId,
    onExtendRescheduleSale,
    extendTxCanReschedule,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const closeButtonMessage = intl.formatMessage({ id: 'RescheduleSaleModal.close' });
  const lastTransition = txLastTransition(transaction);
  const isExtendRescheduleTx = lastTransition === TRANSITION_SAVE_EXTEND_BOOKING ||
    lastTransition === TRANSITION_ACCEPT_EXTEND_BOOKING;
  const isAllowToReschedule =
    lastTransition === TRANSITION_REQUEST_PAYMENT ||
    lastTransition === TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY ||
    lastTransition === TRANSITION_ACCEPT_NEGOTIATE_OFFER ||
    isExtendRescheduleTx;

  if (!isAllowToReschedule) {
    return null;
  }

  const { start: startDate, end: endDate } = get(transaction, 'booking.attributes', {});
  const { seats, deliveryData } = get(transaction, 'attributes.protectedData', {});
  const { delivery } = deliveryData || {};

  const handleSubmit = (values) => {
    const { bookingDates, price } = values;
    const { startDate, endDate } = bookingDates;

    const startDateToLocalNoon = dateFromAPIToLocalNoon(startDate);
    const endDateToLocalNoon = dateFromAPIToLocalNoon(endDate);
    const threeDayBeforeStartDate = moment(startDateToLocalNoon).subtract(3, 'days');
    const TODAY = moment();
    const chargeDate = threeDayBeforeStartDate.isBefore(TODAY) ? TODAY : threeDayBeforeStartDate;
    const chargedTime = getDateForEmail(chargeDate);
    const bondReleaseTime = moment(endDateToLocalNoon).add(60, "hours");

    if (sendMessageButton.current) {
      sendMessageButton.current.click();
    };
    const rescheduleParams = {
      listingId: listing.id,
      bookingStart: startDate,
      bookingEnd: endDate,
      bookingDisplayStart: startDate,
      bookingDisplayEnd: moment(endDate).subtract(1, 'd').endOf('day').toDate(),
      bookingData: {
        startDate,
        endDate,
        delivery,
        seats: parseInt(seats),
        reofferPrice: price,
      },
      protectedData: {
        chargedTime,
        bondReleaseTime: getDateForEmail(bondReleaseTime, true),
        offerStartDate: startDate.getTime(),
        offerEndDate: endDate.getTime(),
        offerMailStartDate: getDateForEmail(startDate),
        offerMailEndDate: getDateForEmail(endDate),
        seats: parseInt(seats),
      },
    }
    if (isExtendRescheduleTx) {
      onExtendRescheduleSale(extendTxCanReschedule.id, rescheduleParams)
    } else {
      onRescheduleSale(transaction.id, rescheduleParams);
    }

  }

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={closeButtonMessage}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="RescheduleSaleModal.title" />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id="RescheduleSaleModal.description" />
      </p>
      <RescheduleSaleForm
        timeSlots={timeSlots}
        onSubmit={handleSubmit}
        listingId={listing.id}
        transaction={transaction}
        transactionId={transaction.id}
        formId="RescheduleSale"
        isOwnListing={isOwnListing}
        rescheduleInProgress={rescheduleInProgress}
        rescheduleSaleError={rescheduleSaleError}
        onFetchReofferTransactionLineItem={onFetchReofferTransactionLineItem}
        lineItems={lineItems}
        fetchLineItemsInProgress={fetchLineItemsInProgress}
        fetchLineItemsError={fetchLineItemsError}
        currentBookingDates={{ startDate, endDate }}
        seats={seats}
        deliveryData={deliveryData}
        listing={listing}
        onChangeAvailabilityExceptionCurrentBooking={onChangeAvailabilityExceptionCurrentBooking}
        exceptionId={exceptionId}
      />
    </Modal>
  );
};

const { string } = PropTypes;

RescheduleSaleModal.defaultProps = {
  className: null,
  rootClassName: null,
};

RescheduleSaleModal.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
};

export default injectIntl(RescheduleSaleModal);
